export default "__VITE_ASSET__BVh8XO_M__"